module.exports = __webpack_public_path__ + "img/pause.039dca64.png";